import React, { useEffect, useState } from "react";
import { RightArrow } from "../../../assets";
import DagaProductCard from "../../Master/DagaProductCard";
import { useGetProductsMutationMutation } from "../../../redux/slices/homeSlice";
import { toast } from "react-toastify";
import { ProductCard } from "../../Pages/Category/Category";

function NewArrivalsBlock({ homeData }) {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [getProductsMutation, { isError, error }] =
    useGetProductsMutationMutation();

  const fetchData = async (page, limit) => {
    try {
      const res = await getProductsMutation({
        body: {},
        page,
        limit,
        queryParams: "new_arrival=1",
      });

      if (res?.data?.products) {
        return res.data.products;
      } else {
        console.error("Error fetching products:", res.error || "Unknown error");
        return [];
      }
    } catch (err) {
      console.error("Fetch failed:", err);
      return [];
    }
  };

  useEffect(() => {
    const loadProducts = async () => {
      setIsLoading(true);
      const newItems = await fetchData(1, 20);
      setProducts(newItems);
      setIsLoading(false);
    };

    loadProducts();
  }, []);

  const ref = React.useRef(null);
  return (
    <div className="bg-bg_1 py-10">
      <div className="text-primary text-3xl lg:text-4xl text-center tracking-[2.65px] my-2 cormorant-medium">
        NEW ARRIVALS
      </div>
      <div className="text-text_dark_2 text-lg lg:text-xl text-center my-2 mb-10 lato-regular">
        Our Latest, Just For You !
      </div>
      <div className="p-4">
        <div
          ref={ref}
          className="grid justify-start grid-flow-col gap-4 overflow-scroll no-scrollbar"
        >
          {isLoading &&
            [{}, {}, {}, {}]?.map((item, index) => (
              <div className="w-[40vw] sm:w-[23.5vw]" key={index}>
                <DagaProductCard />
              </div>
            ))}
          {products?.map((item, index) => (
            <div className="w-[40vw] sm:w-[23.5vw]" key={index}>
              {/* <ProductCard 
              product={item} 
                  /> */}
              <DagaProductCard
                key={index}
                img={item?.image[0]}
                price={item?.price}
                title={item?.title?.en}
                link={`/products/${item?._id}`}
              />
            </div>
          ))}
        </div>
        <div className="flex gap-4 justify-center mt-16">
          <img
            src={RightArrow}
            alt="our store"
            className="border-[1px] border-primary rounded-full p-2 px-5 text-primary cursor-pointer rotate-180"
            onClick={() => {
              ref.current.scroll({
                left: ref.current.scrollLeft - 500,
                behavior: "smooth",
              });
            }}
          />
          <img
            src={RightArrow}
            alt="our store"
            className="border-[1px] border-primary rounded-full p-2 px-5 text-primary cursor-pointer"
            onClick={() => {
              ref.current.scroll({
                left: ref.current.scrollLeft + 500,
                behavior: "smooth",
              });
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default NewArrivalsBlock;
{
  /* <div className="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 px-6 gap-6">
  {products.map((item) => (
    <ProductCard key={item} 
      img={item?.image}
      price={item?.price}
      title={item?.title}
      />
  ))  
  }
</div> */
}
